import React, { useEffect, useState } from 'react'
import { useResErrors } from 'hooks'
import { CarService, SalesService } from 'lib/api'
import { CircularProgress } from 'asterX-UI/Loaders'
import { Divider, makeStyles, Typography } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import CarSelectionCard from 'components/Mobile/Car/CarSelectionCard'
import { Modal } from 'asterX-UI/Modals'
import CarData from 'components/Desktop/Car/CarData'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12,
    width: '100%',
    marginLeft: '15px'
  },
  rowText: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    color: GRAY_COLORS[700],
    fontSize: 14,
    fontWeight: 600
  }
}))
const HistoryOfSelection = ({ id, tradeInCarVin = '' }) => {
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(false)
  const [history, setHistory] = useState({
    demonstratedCars: [],
    selectedCars: []
  })
  const [activeCar, setActiveCar] = useState(null)
  const [tradeInCar, setTradeInCar] = useState(null)
  const { standardCheck } = useResErrors()
  useEffect(() => {
    if (id) {
      getPastSelection()
    }
  }, [])
  useEffect(() => {
    if (tradeInCarVin) {
      getCarByVin()
    }
  }, [tradeInCarVin])
  const getPastSelection = async () => {
    setIsLoading(true)
    await SalesService.getPastSelection(id).then(res =>
      standardCheck(res, () => {
        setHistory(res.data)
      })
    )
    setIsLoading(false)
  }
  const handleCarClick = car => {
    setActiveCar(car)
  }
  const getDemonstrationResults = vin => {
    const car = history?.demonstratedCars?.find(car => car.vin === vin)
    if (car) {
      return {
        resultConfiguration: car?.resultConfiguration,
        resultExternal: car?.resultExternal,
        resultPrice: car?.resultPrice,
        resultTechnical: car?.resultTechnical,
        resultTestDrive: car?.resultTestDrive,
        resultTestDriveExpress: car?.resultTestDriveExpress,
        isNotDemonstrated: car?.isNotDemonstrated,
        comment: car?.comment
      }
    }
    return null
  }
  const getCarByVin = async () => {
    setIsLoading(true)

    await CarService.getCarByVin(tradeInCarVin).then(response =>
      standardCheck(response, () => {
        setTradeInCar(response.data)
      })
    )

    setIsLoading(false)
  }
  return (
    <div className={classes.root}>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          {tradeInCar && <div className={classes.rowText}>Trade-In авто</div>}

          {tradeInCar && (
            <CarSelectionCard
              car={tradeInCar}
              onClick={() => handleCarClick(tradeInCar)}
            />
          )}
          {tradeInCar && (
            <div className={classes.rowText}>
              <Divider />
            </div>
          )}
          {history?.selectedCarsForSale?.length > 0 && (
            <div className={classes.rowText}>Авто на продажу</div>
          )}
          {history?.selectedCarsForSale?.map(car => (
            <CarSelectionCard car={car} onClick={() => handleCarClick(car)} />
          ))}
          {history?.selectedCarsForSale?.length > 0 && (
            <div className={classes.rowText}>
              <Divider />
            </div>
          )}

          {history?.demonstratedCars?.length > 0 && (
            <div className={classes.rowText}>Демонстрация авто</div>
          )}

          {history?.demonstratedCars?.map(car => (
            <CarSelectionCard car={car} onClick={() => handleCarClick(car)} />
          ))}
          {history?.demonstratedCars?.length > 0 && (
            <div className={classes.rowText}>
              <Divider />
            </div>
          )}

          {history?.selectedCars?.length > 0 && (
            <div className={classes.rowText}>Подбор авто</div>
          )}
          {history?.selectedCars?.map(car => (
            <CarSelectionCard car={car} onClick={() => handleCarClick(car)} />
          ))}
          {history?.selectedCars?.length === 0 &&
            history?.demonstratedCars?.length === 0 &&
            history?.selectedCarsForSale?.length === 0 && (
              <Typography variant={'body2'} align={'center'} color={'primary'}>
                Нет данных
              </Typography>
            )}
        </>
      )}
      {activeCar?.id && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={activeCar}
          onClose={() => handleCarClick(null)}
        >
          <CarData
            vin={activeCar.vin}
            demonstrationResults={getDemonstrationResults(activeCar.vin)}
            onClose={() => handleCarClick(null)}
          />
        </Modal>
      )}
    </div>
  )
}
export default HistoryOfSelection
